import React, { useEffect, useState } from "react";
import "./ChatbotWidget.scss";
const CHATBOT_URL = "https://d1x8svzs28gqii.cloudfront.net";
const CHATBOT_ORIGIN = "https://d1x8svzs28gqii.cloudfront.net";
const ChatbotWidget = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleMessage = (event) => {
      // Only accept messages from chatbot
      if (event.origin !== CHATBOT_ORIGIN) {
        return;
      }

      console.log("[ChatbotWidget] Message:", event.data);

      // Chatbot OPEN
      if (event.data?.open === true) {
        console.log("[ChatbotWidget] 🟢 OPEN");
        setIsOpen(true);
      }

      // Chatbot CLOSE
      if (event.data?.open === false) {
        console.log("[ChatbotWidget] 🔴 CLOSE");
        setIsOpen(false);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  const iframeClass = isOpen
    ? "chatbot-widget-frame chatbot-widget-frame--open"
    : "chatbot-widget-frame chatbot-widget-frame--closed";

  return (
    <iframe
      title="KB Chatbot"
      src={CHATBOT_URL}
      className={iframeClass}
      allow="clipboard-write"
    />
  );
};

export default ChatbotWidget;
